import React from "react"
import { getPrixCadre } from "../profcadresprix/index-legacy"
import IconeService from "./../components/iconeService"

const prix_kit_montage = 15

export const kit_montage = 9
export const tva = 1.2 // 20%
export const echantillon_baguette = 3
export const echantillon_doublo = 6
export const echantillon_passe_partout = 0.84

//const serviceLongueur = 1;
const servicePrecoupe = 2
const servicePrecoupeKit = 3
const serviceCoupeAssemble = 4
const serviceCoupeAssembleIsorel = 5
const servicePlexiNormal = 6
const servicePlexiAntiReflet = 7
const serviceVerreNormal = 8
const serviceVerreAntiReflet = 9
const serviceVerreInvisible = 10
const serviceDoubleVerreNormal = 11
const serviceDoubleVerreInvisible = 12
const serviceAstral = 13

export const bordureMin = 2
export const sujetMin = 20
export const options_pp = [
  [1, 2],
  [1, 3],
  [1, 4],
  [2, 2],
  [1, 5],
  [2, 1],
  [3, 1],
  [4, 1],
  [5, 1],
  [6, 1],
  [2, 3],
  [3, 2],
]

export const niveaux = [
  {
    title: "Les cadres aluminium",
    categs: [5, 6],
  },
  { title: "Les cadres bois", categs: [4, 7, 14, 9, 8, 1, 15, 21] },
  {
    title: "Les caisses américaines ou montages spécifiques",
    categs: [10, 3, 12],
  },
  { title: "Les exclusifs", categs: [20, 18, 19, 16, 17] },
]
export const services_rehausse = ["precoupe", "coupe_assemble", "coupe_assemble_isorel", "verre_normal", "verre_invisible", "plexi_normal"]

const alu120 = 476
const alu2100 = 510
const alu350 = 511

const americaF = 509
const cristalF = 475
const astralF = 540

const InEsmFake = [americaF, cristalF, astralF]

export const get_service = product => {
  let servicesConfigurateur = [
    {
      //   Famille vitrine ***
      categorie: 1,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      // montage spécifique pour photo support rigide
      categorie: 3,
      services: [/*serviceLongueur,*/ servicePrecoupe, servicePrecoupeKit, serviceCoupeAssemble, serviceCoupeAssembleIsorel], //a voir
      options: null,
    },
    {
      //   Plat blanc et noir qualité galerie ***
      categorie: 4,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Bois recouvert aluminium ***
      categorie: 5,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Aluminium
      categorie: 6,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Couleur moderne et design ***
      categorie: 7,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Classique , ornement ou baroque ***
      categorie: 8,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Nature , décor bois , placage bois véritable , bla... ***
      categorie: 9,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Caisse américaine châssis peinture
      categorie: 10,
      services: [/*serviceLongueur,*/ servicePrecoupe, servicePrecoupeKit, serviceCoupeAssemble], // aucun verre
      options: [1, 2], // fibranne noir et blanche
    },
    {
      //   Caisse américaine, Pour support papier ***
      categorie: 12,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Cadre avec marie louise ***
      categorie: 13,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Intemporel or ou argent ***
      categorie: 14,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Ethnique , original et fantaisie ***
      categorie: 15,
      services: [
        /*serviceLongueur,*/ servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Entre deux verres ***
      categorie: 16,
      services: [serviceDoubleVerreNormal, serviceDoubleVerreInvisible],
      options: null,
    },
    {
      //   Cadre astral ***
      categorie: 17,
      services: [serviceAstral],
      options: null,
    },
    {
      //   Cadre doublo caisse américaine ***
      categorie: 18,
      services: [serviceCoupeAssemble],
      options: null,
    },
    {
      //   Cadre doublo avec marie louise ***
      categorie: 19,
      services: [
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
    {
      //   Cadre doublo deisgn ***
      categorie: 20,
      services: [
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },

    {
      //   marie louise integrée ***
      categorie: 21,
      services: [
        servicePrecoupe,
        servicePrecoupeKit,
        serviceCoupeAssemble,
        serviceCoupeAssembleIsorel,
        servicePlexiNormal,
        servicePlexiAntiReflet,
        serviceVerreNormal,
        serviceVerreAntiReflet,
        serviceVerreInvisible,
      ],
      options: null,
    },
  ]

  let servicesReturn = []
  servicesConfigurateur.map(produit => {
    if (product.cat_id == produit.categorie) {
      servicesReturn = produit.services
    }
  })

  if (alu120 === product.fa_id || 675 === product.fa_id || 672 === product.fa_id) {
    servicesReturn = [serviceCoupeAssembleIsorel, servicePlexiNormal, servicePlexiAntiReflet, serviceVerreNormal, serviceVerreAntiReflet, serviceVerreInvisible]
  } else if (alu2100 === product.fa_id || alu350 === product.fa_id || 707 === product.fa_id) {
    servicesReturn = [
      servicePrecoupe,
      serviceCoupeAssembleIsorel,
      servicePlexiNormal,
      servicePlexiAntiReflet,
      serviceVerreNormal,
      serviceVerreAntiReflet,
      serviceVerreInvisible,
    ]
  } else if (americaF === product.fa_id) {
    servicesReturn = [servicePrecoupe, servicePrecoupeKit]
  }

  return servicesReturn
}

export const get_service_init = () => {
  let services = {
    precoupe: {
      id: 2,
      title: "Pré Coupé",
      pageProduit: { service: "precoupe" },
      image: <IconeService precoupe={true} />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
    },
    coupe_assemble: {
      id: 4,
      title: "Coupé assemblé",
      pageProduit: { service: "coupe_assemble_option" },
      image: <IconeService />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
    },
    coupe_assemble_isorel: {
      id: 5,
      title: "Coupé assemblé + isorel",
      pageProduit: { isorel: true, service: "coupe_assemble_option" },
      image: <IconeService isorel={true} />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    plexi_normal: {
      id: 6,
      title: "Complet - Plexi normal traité anti UV",
      pageProduit: { isorel: true, protection: "plexi_normal", service: "coupe_assemble_option" },
      image: <IconeService isorel={true} typevitre="plexi_normal" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    plexi_anti_reflet: {
      id: 7,
      title: "Complet - Plexi anti-reflet traité anti UV",
      pageProduit: { isorel: true, protection: "plexi_anti_reflet", service: "coupe_assemble_option" },
      image: <IconeService isorel={true} typevitre="plexi_anti_reflet" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    verre_normal: {
      id: 8,
      title: "Complet - Verre normal",
      pageProduit: { isorel: true, protection: "verre_normal", service: "coupe_assemble_option" },
      image: <IconeService isorel={true} typevitre="verre_normal" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    verre_anti_reflet: {
      id: 9,
      title: "Complet - Verre anti-reflet",
      pageProduit: { isorel: true, protection: "verre_anti_reflet", service: "coupe_assemble_option" },
      image: <IconeService isorel={true} typevitre="verre_anti_reflet" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    verre_invisible: {
      id: 10,
      title: "Complet - Verre qualité musée",
      pageProduit: { isorel: true, protection: "verre_invisible", service: "coupe_assemble_option" },
      image: <IconeService isorel={true} typevitre="verre_invisible" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    double_verre_normal: {
      id: 11,
      title: "Verre normal",
      pageProduit: { isorel: true, protection: "double_verre_normal", service: "coupe_assemble_option" },
      image: <IconeService isorel={false} typevitre="verre_normal" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    double_verre_invisible: {
      id: 12,
      title: "Verre qualité musée",
      pageProduit: { isorel: true, protection: "double_verre_invisible", service: "coupe_assemble_option" },
      image: <IconeService isorel={false} typevitre="verre_invisible" />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
    astral: {
      id: 13,
      title: "Coupé assemblé",
      pageProduit: { protection: "coupe_assemble", service: "coupe_assemble_option" },
      image: <IconeService />,
      prix_unitaire_ht: 0,
      prix_unitaire_ttc: 0,
      prix_unitaire_with_options_ht: 0,
      prix_total_ht: 0,
      prix_total_ttc: 0,
      option_carton_barriere: 0,
    },
  }

  return services
}

export const getMarges = product => {
  let site = 0
  if (product.isInESM === 1 || InEsmFake.includes(product.fa_id)) {
    site = 0
  } else {
    site = 5
  }
  let precoupe = 0
  if (product.ba_marge_precoupe !== null) {
    if (product.ba_marge_precoupe.charAt(0) == "{") {
      precoupe = parseFloat(JSON.parse(product.ba_marge_precoupe)[site])
    } else if (product.ba_marge_precoupe.charAt(0) == "[") {
      precoupe = parseFloat(product.ba_marge_precoupe.replace(/\["|"\]/gi, ""))
    }
  }

  let sur_mesure = 0
  if (product.ba_marge_sur_mesure !== null) {
    if (product.ba_marge_sur_mesure.charAt(0) == "{") {
      sur_mesure = parseFloat(JSON.parse(product.ba_marge_sur_mesure)[site])
    } else if (product.ba_marge_sur_mesure.charAt(0) == "[") {
      sur_mesure = parseFloat(product.ba_marge_sur_mesure.replace(/\["|"\]/gi, ""))
    }
  }

  if (precoupe === 0) {
    precoupe = product.marge_metre_precoupe_ht
  }

  if (sur_mesure === 0) {
    sur_mesure = product.marge_metre_mesure_ht
  }
  return { sur_mesure, precoupe }
}
export const get_prix_services = (product, productAnnexe, hauteur, largeur, quantite, checked, kit_montage_checked = 0) => {
  let services = get_service_init()

  /**
   * Service precoupe
   */
  services.precoupe.prix_unitaire_ht = -1
  services.precoupe.prix_unitaire_with_options_ht = parseFloat(services.precoupe.prix_unitaire_ht)
  if (kit_montage_checked == 1) {
    services.precoupe.prix_unitaire_with_options_ht = (services.precoupe.prix_unitaire_with_options_ht + prix_kit_montage).toFixed(2)
  }
  services.precoupe.prix_total_ht = (services.precoupe.prix_unitaire_with_options_ht * quantite).toFixed(2)
  services.precoupe.prix_total_ttc = (services.precoupe.prix_total_ht * 1.2).toFixed(2)

  /**
   * Service coupe assemble
   */
  services.coupe_assemble.prix_unitaire_ht = -1
  services.coupe_assemble.prix_unitaire_with_options_ht = services.coupe_assemble.prix_unitaire_ht
  services.coupe_assemble.prix_total_ht = (services.coupe_assemble.prix_unitaire_ht * quantite).toFixed(2)
  services.coupe_assemble.prix_total_ttc = (services.coupe_assemble.prix_total_ht * 1.2).toFixed(2)

  /**
   * Service coupe assemble + isorel
   */
  services.coupe_assemble_isorel.option_carton_barriere = 1

  /**
   * Service plexi normal
   */
  services.plexi_normal.option_carton_barriere = 1

  /**
   * Service plexi anti reflet
   */
  services.plexi_anti_reflet.option_carton_barriere = 1

  /**
   * Service verre normal
   */
  services.verre_normal.option_carton_barriere = 1

  /**
   * Service verre anti reflet
   */
  services.verre_anti_reflet.option_carton_barriere = 1

  /**
   * Service verre invisible
   */
  services.verre_invisible.option_carton_barriere = 1

  /**
   * Service entre deux verres normaux
   */
  services.double_verre_normal.option_carton_barriere = 0

  /**
   * Service entre deux verres invisible
   */
  services.double_verre_invisible.option_carton_barriere = 0

  /**
   * Service astral
   */
  services.astral.option_carton_barriere = 0

  return services
}

export const get_perimetre = (product, hauteur, largeur) => {
  const perimetre = ((hauteur + largeur) * 2) / 100

  const perimetreChutes = (perimetre + (8 * product.ba_largeur) / 100) * (1 + product.ba_chutes / 100)

  return perimetreChutes
}

/**
 * DEPRECATED
 * Retourne le prix HT
 * @param {} product
 * @param {*} pageProduit
 * @param {*} pa
 */
export const getPrix = (product, pageProduit, pa) => {
  process.env.NODE_ENV !== "production" && console.log("fonction getPrix dans prixBaguette dépréciée")
  if (typeof product.ba_id !== "undefined") {
    return getPrixCadre(
      product,
      { ...pageProduit, pp: { ouvertures: [1, 1], interL: 0, interH: 0, margeG: 0, margeD: 0, margeH: 0, margeB: 0 } },
      pa.map(e => e.node),
      { photos: [], tirage: null }
    )
  }
}
